export const collectionData = [
  {
    image: require("../../assets/mobile/card_images/1.png"),
    heading: "A horse with rabbit head",
  },
  {
    image: require("../../assets/mobile/card_images/2.png"),
    heading: "Bleys Tom realistic",
  },
  {
    image: require("../../assets/mobile/card_images/3.png"),
    heading: "A horse with rabbit head",
  },
  {
    image: require("../../assets/mobile/card_images/4.png"),
    heading: "A horse with rabbit head",
  },
  {
    image: require("../../assets/mobile/card_images/5.png"),
    heading: "A horse with rabbit head",
  },
  {
    image: require("../../assets/mobile/card_images/6.png"),
    heading: "A horse with rabbit head",
  },
];
